import { Box, styled, Typography } from "@mui/material";
import Select from "components/Select";
import { WALLET_TYPE } from "pages/BasicTrade/components/constants";
import CoinSelectItem from "pages/Wallet/Component/FilterMarginHistory/Component/CoinSelectItem";
import React from "react";
import { useSearchParams } from "react-router-dom";
function SelectValueBalance() {
  const [searchParams, setSearchParams] = useSearchParams();
  const valueBalance = +searchParams.get("valueBalance") || 0;
  const walletTypeId = +searchParams.get("walletTypeId") || 1;
  const allSearchParams = Object.fromEntries([...searchParams]);

  const listValueBalance = [
    { id: 0, name: "USDT", imageUrl: "/images/coin/usdt.png" },
    { id: 1, name: "Toman", imageUrl: "/images/coin/toman.png" },
  ];

  const handleChangeValueBalance = (e) => {
    const value = e.target.value;
    setSearchParams({
      ...allSearchParams,
      valueBalance: value,
    });
  };
  return (
    <BoxValueBalance>
      <Typography variant="h6" mr={1} color="text.main" width="100%">
        {walletTypeId === WALLET_TYPE.spot ? "Value Blnc" : "Equity Blnc"}
      </Typography>

      <SelectStyle
        items={listValueBalance}
        itemValue="id"
        itemText="name"
        dir="ltr"
        value={valueBalance}
        onChange={handleChangeValueBalance}
        customValue={(data) => <CoinSelectItem data={data} />}
      />
    </BoxValueBalance>
  );
}
const BoxValueBalance = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(2),

  [theme.breakpoints.down("sm")]: {
    width: " 100%",
    paddingLeft: "0px",
  },
}));

const SelectStyle = styled(Select)(({ theme }) => ({
  textAlign: "center",
  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 0.5),
    fontSize: "12px",
  },
  minWidth: " 120px",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "120px",
  },
}));
export default SelectValueBalance;
